import axios from "../axios/axios";
import { errorDispatcher } from "../helpers";

const modelsToSync = [
    // 'currencies',
    "accountType",
    "category",
    "personType",
    "project",
    "branch",
    "warehouse",
    "financial",
    "person",
    "personSetting",
    "shareholder",
    "product",
    "productSetting",
    "barcode",
    "transfer",
    "factor",
    "transaction",
    "cheque",
    "bill",
    "accounting",
];

export const apiGetLastSync = (token, callback) => (dispatch, getState) => {
    axios
        .get("sync/last", {
            headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
            callback(response.data);
        })
        .catch((error) => {
            // errorDispatcher(error, dispatch);
        });
};

export const apiSync =
    (token, model, callback, failure, index = 0) =>
        (dispatch, getState) => {
            axios
                .post(`sync?modelName=${model}`, {}, {
                    headers: { Authorization: `Bearer ${token}` },
                })
                .then((response) => {
                    callback(response.data);
                })
                .catch((error) => {
                    failure();
                    errorDispatcher(error, dispatch);
                });
        };

export const apiSyncAll =
    (token, callback, failure, index = 0) =>
        (dispatch, getState) => {
            const model = modelsToSync[index];
            const syncedModels = [];

            if (model) {
                axios
                    .get(`sync?modelName=${model}`, {
                        headers: { Authorization: `Bearer ${token}` },
                    })
                    .then((response) => {
                        syncedModels.push({ model, data: response.data.data });
                        dispatch(apiSync(token, callback, failure, index + 1));
                    })
                    .catch((error) => {
                        failure();
                        errorDispatcher(error, dispatch);
                    });
            } else {
                callback(syncedModels);
            }
        };

export const apiSynced = (token, callback, failure) => (dispatch, getState) => {
    axios
        .put(
            "sync",
            {},
            {
                headers: { Authorization: `Bearer ${token}` },
            }
        )
        .then((response) => {
            callback(response.data.lastSync);
        })
        .catch((error) => {
            failure();
            errorDispatcher(error, dispatch);
        });
};
